import { render } from "./CalendarItem.vue?vue&type=template&id=2b748038&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"

import "./CalendarItem.vue?vue&type=style&index=0&id=2b748038&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b748038"]])

export default __exports__